module.exports = __webpack_public_path__ + "img/image_core02@2x.8a2de7dd.png";